/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Mediaslider_Previousslide2Inputs */

const id_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide sebelumnya`)
};

const ms_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slaid sebelumnya`)
};

const da_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige slide`)
};

const de_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Folie`)
};

const en_us2_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const es_es2_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva anterior`)
};

const es_mx2_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva anterior`)
};

const fil_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakaraang slide`)
};

const fr_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositive précédente`)
};

const it_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide precedente`)
};

const hu_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előző dia`)
};

const nl_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorige dia`)
};

const no_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige lysbilde`)
};

const pl_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzedni slajd`)
};

const pt_br2_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const pt_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide anterior`)
};

const ro_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide anterior`)
};

const fi_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edellinen dia`)
};

const sv_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föregående bild`)
};

const vi_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang trình chiếu trước`)
};

const tr_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki slayt`)
};

const cs_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předchozí snímek`)
};

const bg_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предишен слайд`)
};

const ru_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущий слайд`)
};

const uk_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попередній слайд`)
};

const ar_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشريحة السابقة`)
};

const hi_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली स्लाइड`)
};

const th_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สไลด์ก่อนหน้า`)
};

const ja_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のスライド`)
};

const zh_cn2_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const zh_hant1_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const ko_components_mediaslider_previousslide2 = /** @type {(inputs: Components_Mediaslider_Previousslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

/**
* | output |
* | --- |
* | "Previous slide" |
*
* @param {Components_Mediaslider_Previousslide2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_mediaslider_previousslide2 = /** @type {((inputs?: Components_Mediaslider_Previousslide2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Mediaslider_Previousslide2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_mediaslider_previousslide2(inputs)
	if (locale === "ms") return ms_components_mediaslider_previousslide2(inputs)
	if (locale === "da") return da_components_mediaslider_previousslide2(inputs)
	if (locale === "de") return de_components_mediaslider_previousslide2(inputs)
	if (locale === "en-US") return en_us2_components_mediaslider_previousslide2(inputs)
	if (locale === "es-ES") return es_es2_components_mediaslider_previousslide2(inputs)
	if (locale === "es-MX") return es_mx2_components_mediaslider_previousslide2(inputs)
	if (locale === "fil") return fil_components_mediaslider_previousslide2(inputs)
	if (locale === "fr") return fr_components_mediaslider_previousslide2(inputs)
	if (locale === "it") return it_components_mediaslider_previousslide2(inputs)
	if (locale === "hu") return hu_components_mediaslider_previousslide2(inputs)
	if (locale === "nl") return nl_components_mediaslider_previousslide2(inputs)
	if (locale === "no") return no_components_mediaslider_previousslide2(inputs)
	if (locale === "pl") return pl_components_mediaslider_previousslide2(inputs)
	if (locale === "pt-BR") return pt_br2_components_mediaslider_previousslide2(inputs)
	if (locale === "pt") return pt_components_mediaslider_previousslide2(inputs)
	if (locale === "ro") return ro_components_mediaslider_previousslide2(inputs)
	if (locale === "fi") return fi_components_mediaslider_previousslide2(inputs)
	if (locale === "sv") return sv_components_mediaslider_previousslide2(inputs)
	if (locale === "vi") return vi_components_mediaslider_previousslide2(inputs)
	if (locale === "tr") return tr_components_mediaslider_previousslide2(inputs)
	if (locale === "cs") return cs_components_mediaslider_previousslide2(inputs)
	if (locale === "bg") return bg_components_mediaslider_previousslide2(inputs)
	if (locale === "ru") return ru_components_mediaslider_previousslide2(inputs)
	if (locale === "uk") return uk_components_mediaslider_previousslide2(inputs)
	if (locale === "ar") return ar_components_mediaslider_previousslide2(inputs)
	if (locale === "hi") return hi_components_mediaslider_previousslide2(inputs)
	if (locale === "th") return th_components_mediaslider_previousslide2(inputs)
	if (locale === "ja") return ja_components_mediaslider_previousslide2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_mediaslider_previousslide2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_mediaslider_previousslide2(inputs)
	return ko_components_mediaslider_previousslide2(inputs)
});
export { components_mediaslider_previousslide2 as "components.mediaSlider.previousSlide" }